import { render, staticRenderFns } from "./shopify_configurator.vue?vue&type=template&id=db6b37a2&"
import script from "./shopify_configurator.vue?vue&type=script&lang=js&"
export * from "./shopify_configurator.vue?vue&type=script&lang=js&"
import style0 from "./shopify_configurator.vue?vue&type=style&index=0&id=db6b37a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports